import * as type from './type';
import util from 'common/js/util';

export default{
    //获取订单列表(买家)
    [type.GET_ORDER_LIST](context,option){
        util.post({
            params:{
                functionId: "getOrderLists",
                body: JSON.stringify({
                    currentPage: option.params.currentPage,
                    pageSize: option.params.pageSize,
                    purOrderStatus: option.params.purOrderStatus,
                    queryScope: 2   //1:万商自营  2:万商自营+万商第三方
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //获取订单详情(买家)
    [type.GET_ORDER_ITEM](context,option){
        util.post({
            params:{
                functionId: "queryOneOrder",
                body: JSON.stringify({
                    id: option.params.id
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //取消订单
    [type.CANCEL_ORDER](context,option){
        util.post({
            params:{
                functionId: "cancelOneOrder",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //获取取消订单原因
    [type.GET_CANCEL_ORDER_REASON](context,option){
        util.post({
            params:{
                functionId: "getCancelOrderReason",
                body: JSON.stringify({
                    id: option.params.id
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //获取取消订单流程文案
    [type.GET_CANCEL_ORDER_NODE](context,option){
        util.post({
            params:{
                functionId: "getCancelOrderNode",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //去支付
    [type.GO_PAY](context,option){
        let self = this;
        util.post({
            params:{
                functionId: "orderPay",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //获取物流详情
    [type.GET_LOGISTIC](context,option){
        util.post({
            params:{
                functionId: "getOrderTrack",
                body: JSON.stringify(option.params)
            },
            sc (data){
                context.commit(type.SET_LOGISTIC, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取订单列表(卖家)
    [type.GET_SELLER_ORDER_LIST](context,option){
        util.post({
            params:{
                functionId: "sellerGetOrderList",
                //todo: 入参
                body: JSON.stringify({
                    currentPage: option.params.currentPage,
                    pageSize: option.params.pageSize,
                    purOrderStatus: option.params.purOrderStatus,
                    venderId: option.params.venderId,
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //获取订单详情(卖家)
    [type.GET_SELLER_ORDER_ITEM](context,option){
        util.post({
            params:{
                functionId: "sellerGetOrderDetail",
                body: JSON.stringify({
                    buyerAES: option.params.buyerAES,
                    jdOrderId: option.params.jdOrderId
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //获取快递公司信息
    [type.GET_EXPRESS_COMPANIES](context,option){
        util.post({
            params:{
                functionId: "sellerChoiceExpressCompanies",
                body: JSON.stringify({
                })
            },
            sc (data){
                context.commit(type.SET_EXPRESS_COMPANIES, data.data);
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //出库
    [type.ORDER_SHIPPING](context,option){
        util.post({
            params:{
                functionId: "sellerOrderShipping",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //确认收货
    [type.CONFIRMDELIVERY](context,option){
        util.post({
            params:{
                functionId: "confirmReceipt",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //三方卖家导出订单
    [type.SELLER_EXPORT_ORDER](context,option){
        util.post({
            params:{
                functionId: "getSellerOrderExport",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //确认是否使用物权转移
    [type.ORDER_IS_USE_WUQUAN](context,option){
        util.post({
            params:{
                functionId: "confirmWqzyOrder",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //确认配送物权转移订单
    [type.CONFIRM_DELIVERY_WUQUAN_ORDER](context,option){
        util.post({
            params:{
                functionId: "transportOrder",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取卖家是否开通上门取件
    [type.GET_PICK_STATUS](context,option){
        util.post({
            params:{
                functionId: "getOpenDoorPickStatus",
                body: JSON.stringify(option.params)
            },
            sc (data){
                context.commit(type.SET_PICK_STATUS, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //开通上门取件
    [type.OPEN_DOOR_PICK](context,option){
        util.post({
            params:{
                functionId: "openDoorPick",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.SELLER_ORDER_DOOR_PICK](context,option){
        util.post({
            params:{
                functionId: "sellerOrderDoorPick",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_TRADE_TYPE](context,option){
        util.post({
            params:{
                functionId: "getTradeType",
                body: JSON.stringify(option.params)
            },
            sc (data){
                context.commit(type.SET_TRADE_TYPE, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },



}



// WEBPACK FOOTER //
// ./src/store/my-order/actions.js